import { render, staticRenderFns } from "./page-background-categories.vue?vue&type=template&id=bc99fe32&scoped=true"
import script from "./page-background-categories.vue?vue&type=script&lang=ts"
export * from "./page-background-categories.vue?vue&type=script&lang=ts"
import style0 from "./page-background-categories.vue?vue&type=style&index=0&id=bc99fe32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc99fe32",
  null
  
)

export default component.exports